var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/mout/object/hasOwn.js
var require_hasOwn = __commonJS({
  "../../node_modules/mout/object/hasOwn.js"(exports, module) {
    "use strict";
    function hasOwn(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    __name(hasOwn, "hasOwn");
    module.exports = hasOwn;
  }
});

// ../../node_modules/mout/object/forIn.js
var require_forIn = __commonJS({
  "../../node_modules/mout/object/forIn.js"(exports, module) {
    "use strict";
    var hasOwn = require_hasOwn();
    var _hasDontEnumBug;
    var _dontEnums;
    function checkDontEnum() {
      _dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
      ];
      _hasDontEnumBug = true;
      for (var key in {
        "toString": null
      }) {
        _hasDontEnumBug = false;
      }
    }
    __name(checkDontEnum, "checkDontEnum");
    function forIn(obj, fn, thisObj) {
      var key, i = 0;
      if (_hasDontEnumBug == null) checkDontEnum();
      for (key in obj) {
        if (exec(fn, obj, key, thisObj) === false) {
          break;
        }
      }
      if (_hasDontEnumBug) {
        var ctor = obj.constructor, isProto = !!ctor && obj === ctor.prototype;
        while (key = _dontEnums[i++]) {
          if ((key !== "constructor" || !isProto && hasOwn(obj, key)) && obj[key] !== Object.prototype[key]) {
            if (exec(fn, obj, key, thisObj) === false) {
              break;
            }
          }
        }
      }
    }
    __name(forIn, "forIn");
    function exec(fn, obj, key, thisObj) {
      return fn.call(thisObj, obj[key], key, obj);
    }
    __name(exec, "exec");
    module.exports = forIn;
  }
});

// ../../node_modules/mout/object/functions.js
var require_functions = __commonJS({
  "../../node_modules/mout/object/functions.js"(exports, module) {
    "use strict";
    var forIn = require_forIn();
    function functions(obj) {
      var keys = [];
      forIn(obj, function(val, key) {
        if (typeof val === "function") {
          keys.push(key);
        }
      });
      return keys.sort();
    }
    __name(functions, "functions");
    module.exports = functions;
  }
});

// ../../node_modules/mout/array/slice.js
var require_slice = __commonJS({
  "../../node_modules/mout/array/slice.js"(exports, module) {
    "use strict";
    function slice(arr, start, end) {
      var len = arr.length;
      if (start == null) {
        start = 0;
      } else if (start < 0) {
        start = Math.max(len + start, 0);
      } else {
        start = Math.min(start, len);
      }
      if (end == null) {
        end = len;
      } else if (end < 0) {
        end = Math.max(len + end, 0);
      } else {
        end = Math.min(end, len);
      }
      var result = [];
      while (start < end) {
        result.push(arr[start++]);
      }
      return result;
    }
    __name(slice, "slice");
    module.exports = slice;
  }
});

// ../../node_modules/mout/function/bind.js
var require_bind = __commonJS({
  "../../node_modules/mout/function/bind.js"(exports, module) {
    "use strict";
    var slice = require_slice();
    function bind(fn, context, args) {
      var argsArr = slice(arguments, 2);
      return function() {
        return fn.apply(context, argsArr.concat(slice(arguments)));
      };
    }
    __name(bind, "bind");
    module.exports = bind;
  }
});

// ../../node_modules/mout/array/forEach.js
var require_forEach = __commonJS({
  "../../node_modules/mout/array/forEach.js"(exports, module) {
    "use strict";
    function forEach(arr, callback, thisObj) {
      if (arr == null) {
        return;
      }
      var i = -1, len = arr.length;
      while (++i < len) {
        if (callback.call(thisObj, arr[i], i, arr) === false) {
          break;
        }
      }
    }
    __name(forEach, "forEach");
    module.exports = forEach;
  }
});

// ../../node_modules/mout/object/bindAll.js
var require_bindAll = __commonJS({
  "../../node_modules/mout/object/bindAll.js"(exports, module) {
    "use strict";
    var functions = require_functions();
    var bind = require_bind();
    var forEach = require_forEach();
    var slice = require_slice();
    function bindAll(obj, rest_methodNames) {
      var keys = arguments.length > 1 ? slice(arguments, 1) : functions(obj);
      forEach(keys, function(key) {
        obj[key] = bind(obj[key], obj);
      });
    }
    __name(bindAll, "bindAll");
    module.exports = bindAll;
  }
});

// ../../node_modules/mout/object/forOwn.js
var require_forOwn = __commonJS({
  "../../node_modules/mout/object/forOwn.js"(exports, module) {
    "use strict";
    var hasOwn = require_hasOwn();
    var forIn = require_forIn();
    function forOwn(obj, fn, thisObj) {
      forIn(obj, function(val, key) {
        if (hasOwn(obj, key)) {
          return fn.call(thisObj, obj[key], key, obj);
        }
      });
    }
    __name(forOwn, "forOwn");
    module.exports = forOwn;
  }
});

// ../../node_modules/mout/function/identity.js
var require_identity = __commonJS({
  "../../node_modules/mout/function/identity.js"(exports, module) {
    "use strict";
    function identity(val) {
      return val;
    }
    __name(identity, "identity");
    module.exports = identity;
  }
});

// ../../node_modules/mout/function/prop.js
var require_prop = __commonJS({
  "../../node_modules/mout/function/prop.js"(exports, module) {
    "use strict";
    function prop(name) {
      return function(obj) {
        return obj[name];
      };
    }
    __name(prop, "prop");
    module.exports = prop;
  }
});

// ../../node_modules/mout/lang/kindOf.js
var require_kindOf = __commonJS({
  "../../node_modules/mout/lang/kindOf.js"(exports, module) {
    "use strict";
    function kindOf(val) {
      return Object.prototype.toString.call(val).slice(8, -1);
    }
    __name(kindOf, "kindOf");
    module.exports = kindOf;
  }
});

// ../../node_modules/mout/lang/isKind.js
var require_isKind = __commonJS({
  "../../node_modules/mout/lang/isKind.js"(exports, module) {
    "use strict";
    var kindOf = require_kindOf();
    function isKind(val, kind) {
      return kindOf(val) === kind;
    }
    __name(isKind, "isKind");
    module.exports = isKind;
  }
});

// ../../node_modules/mout/lang/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/mout/lang/isArray.js"(exports, module) {
    "use strict";
    var isKind = require_isKind();
    var isArray = Array.isArray || function(val) {
      return isKind(val, "Array");
    };
    module.exports = isArray;
  }
});

// ../../node_modules/mout/object/deepMatches.js
var require_deepMatches = __commonJS({
  "../../node_modules/mout/object/deepMatches.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var isArray = require_isArray();
    function containsMatch(array, pattern) {
      var i = -1, length = array.length;
      while (++i < length) {
        if (deepMatches(array[i], pattern)) {
          return true;
        }
      }
      return false;
    }
    __name(containsMatch, "containsMatch");
    function matchArray(target, pattern) {
      var i = -1, patternLength = pattern.length;
      while (++i < patternLength) {
        if (!containsMatch(target, pattern[i])) {
          return false;
        }
      }
      return true;
    }
    __name(matchArray, "matchArray");
    function matchObject(target, pattern) {
      var result = true;
      forOwn(pattern, function(val, key) {
        if (!deepMatches(target[key], val)) {
          return result = false;
        }
      });
      return result;
    }
    __name(matchObject, "matchObject");
    function deepMatches(target, pattern) {
      if (target && typeof target === "object" && pattern && typeof pattern === "object") {
        if (isArray(target) && isArray(pattern)) {
          return matchArray(target, pattern);
        } else {
          return matchObject(target, pattern);
        }
      } else {
        return target === pattern;
      }
    }
    __name(deepMatches, "deepMatches");
    module.exports = deepMatches;
  }
});

// ../../node_modules/mout/function/makeIterator_.js
var require_makeIterator = __commonJS({
  "../../node_modules/mout/function/makeIterator_.js"(exports, module) {
    "use strict";
    var identity = require_identity();
    var prop = require_prop();
    var deepMatches = require_deepMatches();
    function makeIterator(src, thisObj) {
      if (src == null) {
        return identity;
      }
      switch (typeof src) {
        case "function":
          return typeof thisObj !== "undefined" ? function(val, i, arr) {
            return src.call(thisObj, val, i, arr);
          } : src;
        case "object":
          return function(val) {
            return deepMatches(val, src);
          };
        case "string":
        case "number":
          return prop(src);
      }
    }
    __name(makeIterator, "makeIterator");
    module.exports = makeIterator;
  }
});

// ../../node_modules/mout/object/some.js
var require_some = __commonJS({
  "../../node_modules/mout/object/some.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var makeIterator = require_makeIterator();
    function some(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      var result = false;
      forOwn(obj, function(val, key) {
        if (callback(val, key, obj)) {
          result = true;
          return false;
        }
      });
      return result;
    }
    __name(some, "some");
    module.exports = some;
  }
});

// ../../node_modules/mout/object/contains.js
var require_contains = __commonJS({
  "../../node_modules/mout/object/contains.js"(exports, module) {
    "use strict";
    var some = require_some();
    function contains(obj, needle) {
      return some(obj, function(val) {
        return val === needle;
      });
    }
    __name(contains, "contains");
    module.exports = contains;
  }
});

// ../../node_modules/mout/lang/isPlainObject.js
var require_isPlainObject = __commonJS({
  "../../node_modules/mout/lang/isPlainObject.js"(exports, module) {
    "use strict";
    function isPlainObject(value) {
      return !!value && typeof value === "object" && value.constructor === Object;
    }
    __name(isPlainObject, "isPlainObject");
    module.exports = isPlainObject;
  }
});

// ../../node_modules/mout/object/deepFillIn.js
var require_deepFillIn = __commonJS({
  "../../node_modules/mout/object/deepFillIn.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var isPlainObject = require_isPlainObject();
    function deepFillIn(target, defaults) {
      var i = 0, n = arguments.length, obj;
      while (++i < n) {
        obj = arguments[i];
        if (obj) {
          forOwn(obj, function(newValue, key) {
            var curValue = target[key];
            if (curValue == null) {
              target[key] = newValue;
            } else if (isPlainObject(curValue) && isPlainObject(newValue)) {
              deepFillIn(curValue, newValue);
            }
          });
        }
      }
      return target;
    }
    __name(deepFillIn, "deepFillIn");
    module.exports = deepFillIn;
  }
});

// ../../node_modules/mout/object/deepMixIn.js
var require_deepMixIn = __commonJS({
  "../../node_modules/mout/object/deepMixIn.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var isPlainObject = require_isPlainObject();
    function deepMixIn(target, objects) {
      var i = 0, n = arguments.length, obj;
      while (++i < n) {
        obj = arguments[i];
        if (obj) {
          forOwn(obj, copyProp, target);
        }
      }
      return target;
    }
    __name(deepMixIn, "deepMixIn");
    function copyProp(val, key) {
      var existing = this[key];
      if (isPlainObject(val) && isPlainObject(existing)) {
        deepMixIn(existing, val);
      } else {
        this[key] = val;
      }
    }
    __name(copyProp, "copyProp");
    module.exports = deepMixIn;
  }
});

// ../../node_modules/mout/object/every.js
var require_every = __commonJS({
  "../../node_modules/mout/object/every.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var makeIterator = require_makeIterator();
    function every(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      var result = true;
      forOwn(obj, function(val, key) {
        if (!callback(val, key, obj)) {
          result = false;
          return false;
        }
      });
      return result;
    }
    __name(every, "every");
    module.exports = every;
  }
});

// ../../node_modules/mout/lang/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/mout/lang/isObject.js"(exports, module) {
    "use strict";
    var isKind = require_isKind();
    function isObject(val) {
      return isKind(val, "Object");
    }
    __name(isObject, "isObject");
    module.exports = isObject;
  }
});

// ../../node_modules/mout/lang/is.js
var require_is = __commonJS({
  "../../node_modules/mout/lang/is.js"(exports, module) {
    "use strict";
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      }
      return x !== x && y !== y;
    }
    __name(is, "is");
    module.exports = is;
  }
});

// ../../node_modules/mout/object/equals.js
var require_equals = __commonJS({
  "../../node_modules/mout/object/equals.js"(exports, module) {
    "use strict";
    var hasOwn = require_hasOwn();
    var every = require_every();
    var isObject = require_isObject();
    var is = require_is();
    function makeCompare(callback) {
      return function(value, key) {
        return hasOwn(this, key) && callback(value, this[key]);
      };
    }
    __name(makeCompare, "makeCompare");
    function checkProperties(value, key) {
      return hasOwn(this, key);
    }
    __name(checkProperties, "checkProperties");
    function equals(a, b, callback) {
      callback = callback || is;
      if (!isObject(a) || !isObject(b)) {
        return callback(a, b);
      }
      return every(a, makeCompare(callback), b) && every(b, checkProperties, a);
    }
    __name(equals, "equals");
    module.exports = equals;
  }
});

// ../../node_modules/mout/object/fillIn.js
var require_fillIn = __commonJS({
  "../../node_modules/mout/object/fillIn.js"(exports, module) {
    "use strict";
    var forEach = require_forEach();
    var slice = require_slice();
    var forOwn = require_forOwn();
    function fillIn(obj, var_defaults) {
      forEach(slice(arguments, 1), function(base) {
        forOwn(base, function(val, key) {
          if (obj[key] == null) {
            obj[key] = val;
          }
        });
      });
      return obj;
    }
    __name(fillIn, "fillIn");
    module.exports = fillIn;
  }
});

// ../../node_modules/mout/object/filter.js
var require_filter = __commonJS({
  "../../node_modules/mout/object/filter.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var makeIterator = require_makeIterator();
    function filterValues(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      var output = {};
      forOwn(obj, function(value, key, obj2) {
        if (callback(value, key, obj2)) {
          output[key] = value;
        }
      });
      return output;
    }
    __name(filterValues, "filterValues");
    module.exports = filterValues;
  }
});

// ../../node_modules/mout/object/find.js
var require_find = __commonJS({
  "../../node_modules/mout/object/find.js"(exports, module) {
    "use strict";
    var some = require_some();
    var makeIterator = require_makeIterator();
    function find(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      var result;
      some(obj, function(value, key, obj2) {
        if (callback(value, key, obj2)) {
          result = value;
          return true;
        }
      });
      return result;
    }
    __name(find, "find");
    module.exports = find;
  }
});

// ../../node_modules/mout/object/flatten.js
var require_flatten = __commonJS({
  "../../node_modules/mout/object/flatten.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var isPlainObject = require_isPlainObject();
    function flattenTo(obj, result, prefix, level) {
      forOwn(obj, function(value, key) {
        var nestedPrefix = prefix ? prefix + "." + key : key;
        if (level !== 0 && isPlainObject(value)) {
          flattenTo(value, result, nestedPrefix, level - 1);
        } else {
          result[nestedPrefix] = value;
        }
      });
      return result;
    }
    __name(flattenTo, "flattenTo");
    function flatten(obj, level) {
      if (obj == null) {
        return {};
      }
      level = level == null ? -1 : level;
      return flattenTo(obj, {}, "", level);
    }
    __name(flatten, "flatten");
    module.exports = flatten;
  }
});

// ../../node_modules/mout/lang/isPrimitive.js
var require_isPrimitive = __commonJS({
  "../../node_modules/mout/lang/isPrimitive.js"(exports, module) {
    "use strict";
    function isPrimitive(value) {
      switch (typeof value) {
        case "string":
        case "number":
        case "boolean":
          return true;
      }
      return value == null;
    }
    __name(isPrimitive, "isPrimitive");
    module.exports = isPrimitive;
  }
});

// ../../node_modules/mout/object/get.js
var require_get = __commonJS({
  "../../node_modules/mout/object/get.js"(exports, module) {
    "use strict";
    var isPrimitive = require_isPrimitive();
    function get(obj, prop) {
      if (!obj) return;
      var parts = prop.split("."), last = parts.pop();
      while (prop = parts.shift()) {
        obj = obj[prop];
        if (obj == null) return;
      }
      return obj[last];
    }
    __name(get, "get");
    module.exports = get;
  }
});

// ../../node_modules/mout/object/has.js
var require_has = __commonJS({
  "../../node_modules/mout/object/has.js"(exports, module) {
    "use strict";
    var get = require_get();
    var UNDEF;
    function has(obj, prop) {
      return get(obj, prop) !== UNDEF;
    }
    __name(has, "has");
    module.exports = has;
  }
});

// ../../node_modules/mout/object/keys.js
var require_keys = __commonJS({
  "../../node_modules/mout/object/keys.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var keys = Object.keys || function(obj) {
      var keys2 = [];
      forOwn(obj, function(val, key) {
        keys2.push(key);
      });
      return keys2;
    };
    module.exports = keys;
  }
});

// ../../node_modules/mout/object/map.js
var require_map = __commonJS({
  "../../node_modules/mout/object/map.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var makeIterator = require_makeIterator();
    function mapValues(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      var output = {};
      forOwn(obj, function(val, key, obj2) {
        output[key] = callback(val, key, obj2);
      });
      return output;
    }
    __name(mapValues, "mapValues");
    module.exports = mapValues;
  }
});

// ../../node_modules/mout/object/matches.js
var require_matches = __commonJS({
  "../../node_modules/mout/object/matches.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    function matches(target, props) {
      var result = true;
      forOwn(props, function(val, key) {
        if (target[key] !== val) {
          return result = false;
        }
      });
      return result;
    }
    __name(matches, "matches");
    module.exports = matches;
  }
});

// ../../node_modules/mout/array/max.js
var require_max = __commonJS({
  "../../node_modules/mout/array/max.js"(exports, module) {
    "use strict";
    var makeIterator = require_makeIterator();
    function max(arr, iterator, thisObj) {
      if (arr == null || !arr.length) {
        return Infinity;
      } else if (arr.length && !iterator) {
        return Math.max.apply(Math, arr);
      } else {
        iterator = makeIterator(iterator, thisObj);
        var result, compare = -Infinity, value, temp;
        var i = -1, len = arr.length;
        while (++i < len) {
          value = arr[i];
          temp = iterator(value, i, arr);
          if (temp > compare) {
            compare = temp;
            result = value;
          }
        }
        return result;
      }
    }
    __name(max, "max");
    module.exports = max;
  }
});

// ../../node_modules/mout/object/values.js
var require_values = __commonJS({
  "../../node_modules/mout/object/values.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    function values(obj) {
      var vals = [];
      forOwn(obj, function(val, key) {
        vals.push(val);
      });
      return vals;
    }
    __name(values, "values");
    module.exports = values;
  }
});

// ../../node_modules/mout/object/max.js
var require_max2 = __commonJS({
  "../../node_modules/mout/object/max.js"(exports, module) {
    "use strict";
    var arrMax = require_max();
    var values = require_values();
    function max(obj, compareFn) {
      return arrMax(values(obj), compareFn);
    }
    __name(max, "max");
    module.exports = max;
  }
});

// ../../node_modules/mout/object/mixIn.js
var require_mixIn = __commonJS({
  "../../node_modules/mout/object/mixIn.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    function mixIn(target, objects) {
      var i = 0, n = arguments.length, obj;
      while (++i < n) {
        obj = arguments[i];
        if (obj != null) {
          forOwn(obj, copyProp, target);
        }
      }
      return target;
    }
    __name(mixIn, "mixIn");
    function copyProp(val, key) {
      this[key] = val;
    }
    __name(copyProp, "copyProp");
    module.exports = mixIn;
  }
});

// ../../node_modules/mout/lang/clone.js
var require_clone = __commonJS({
  "../../node_modules/mout/lang/clone.js"(exports, module) {
    "use strict";
    var kindOf = require_kindOf();
    var isPlainObject = require_isPlainObject();
    var mixIn = require_mixIn();
    function clone(val) {
      switch (kindOf(val)) {
        case "Object":
          return cloneObject(val);
        case "Array":
          return cloneArray(val);
        case "RegExp":
          return cloneRegExp(val);
        case "Date":
          return cloneDate(val);
        default:
          return val;
      }
    }
    __name(clone, "clone");
    function cloneObject(source) {
      if (isPlainObject(source)) {
        return mixIn({}, source);
      } else {
        return source;
      }
    }
    __name(cloneObject, "cloneObject");
    function cloneRegExp(r) {
      var flags = "";
      flags += r.multiline ? "m" : "";
      flags += r.global ? "g" : "";
      flags += r.ignoreCase ? "i" : "";
      return new RegExp(r.source, flags);
    }
    __name(cloneRegExp, "cloneRegExp");
    function cloneDate(date) {
      return /* @__PURE__ */ new Date(+date);
    }
    __name(cloneDate, "cloneDate");
    function cloneArray(arr) {
      return arr.slice();
    }
    __name(cloneArray, "cloneArray");
    module.exports = clone;
  }
});

// ../../node_modules/mout/lang/deepClone.js
var require_deepClone = __commonJS({
  "../../node_modules/mout/lang/deepClone.js"(exports, module) {
    "use strict";
    var clone = require_clone();
    var forOwn = require_forOwn();
    var kindOf = require_kindOf();
    var isPlainObject = require_isPlainObject();
    function deepClone(val, instanceClone) {
      switch (kindOf(val)) {
        case "Object":
          return cloneObject(val, instanceClone);
        case "Array":
          return cloneArray(val, instanceClone);
        default:
          return clone(val);
      }
    }
    __name(deepClone, "deepClone");
    function cloneObject(source, instanceClone) {
      if (isPlainObject(source)) {
        var out = {};
        forOwn(source, function(val, key) {
          this[key] = deepClone(val, instanceClone);
        }, out);
        return out;
      } else if (instanceClone) {
        return instanceClone(source);
      } else {
        return source;
      }
    }
    __name(cloneObject, "cloneObject");
    function cloneArray(arr, instanceClone) {
      var out = [], i = -1, n = arr.length, val;
      while (++i < n) {
        out[i] = deepClone(arr[i], instanceClone);
      }
      return out;
    }
    __name(cloneArray, "cloneArray");
    module.exports = deepClone;
  }
});

// ../../node_modules/mout/object/merge.js
var require_merge = __commonJS({
  "../../node_modules/mout/object/merge.js"(exports, module) {
    "use strict";
    var hasOwn = require_hasOwn();
    var deepClone = require_deepClone();
    var isObject = require_isObject();
    function merge() {
      var i = 1, key, val, obj, target;
      target = deepClone(arguments[0]);
      while (obj = arguments[i++]) {
        for (key in obj) {
          if (!hasOwn(obj, key)) {
            continue;
          }
          val = obj[key];
          if (isObject(val) && isObject(target[key])) {
            target[key] = merge(target[key], val);
          } else {
            target[key] = deepClone(val);
          }
        }
      }
      return target;
    }
    __name(merge, "merge");
    module.exports = merge;
  }
});

// ../../node_modules/mout/array/min.js
var require_min = __commonJS({
  "../../node_modules/mout/array/min.js"(exports, module) {
    "use strict";
    var makeIterator = require_makeIterator();
    function min(arr, iterator, thisObj) {
      if (arr == null || !arr.length) {
        return -Infinity;
      } else if (arr.length && !iterator) {
        return Math.min.apply(Math, arr);
      } else {
        iterator = makeIterator(iterator, thisObj);
        var result, compare = Infinity, value, temp;
        var i = -1, len = arr.length;
        while (++i < len) {
          value = arr[i];
          temp = iterator(value, i, arr);
          if (temp < compare) {
            compare = temp;
            result = value;
          }
        }
        return result;
      }
    }
    __name(min, "min");
    module.exports = min;
  }
});

// ../../node_modules/mout/object/min.js
var require_min2 = __commonJS({
  "../../node_modules/mout/object/min.js"(exports, module) {
    "use strict";
    var arrMin = require_min();
    var values = require_values();
    function min(obj, iterator) {
      return arrMin(values(obj), iterator);
    }
    __name(min, "min");
    module.exports = min;
  }
});

// ../../node_modules/mout/object/namespace.js
var require_namespace = __commonJS({
  "../../node_modules/mout/object/namespace.js"(exports, module) {
    "use strict";
    var forEach = require_forEach();
    function namespace(obj, path) {
      if (!path) return obj;
      forEach(path.split("."), function(key) {
        if (!obj[key]) {
          obj[key] = {};
        }
        obj = obj[key];
      });
      return obj;
    }
    __name(namespace, "namespace");
    module.exports = namespace;
  }
});

// ../../node_modules/mout/array/indexOf.js
var require_indexOf = __commonJS({
  "../../node_modules/mout/array/indexOf.js"(exports, module) {
    "use strict";
    function indexOf(arr, item, fromIndex) {
      fromIndex = fromIndex || 0;
      if (arr == null) {
        return -1;
      }
      var len = arr.length, i = fromIndex < 0 ? len + fromIndex : fromIndex;
      while (i < len) {
        if (arr[i] === item) {
          return i;
        }
        i++;
      }
      return -1;
    }
    __name(indexOf, "indexOf");
    module.exports = indexOf;
  }
});

// ../../node_modules/mout/array/contains.js
var require_contains2 = __commonJS({
  "../../node_modules/mout/array/contains.js"(exports, module) {
    "use strict";
    var indexOf = require_indexOf();
    function contains(arr, val) {
      return indexOf(arr, val) !== -1;
    }
    __name(contains, "contains");
    module.exports = contains;
  }
});

// ../../node_modules/mout/object/omit.js
var require_omit = __commonJS({
  "../../node_modules/mout/object/omit.js"(exports, module) {
    "use strict";
    var slice = require_slice();
    var contains = require_contains2();
    function omit(obj, var_keys) {
      var keys = typeof arguments[1] !== "string" ? arguments[1] : slice(arguments, 1), out = {};
      for (var property in obj) {
        if (obj.hasOwnProperty(property) && !contains(keys, property)) {
          out[property] = obj[property];
        }
      }
      return out;
    }
    __name(omit, "omit");
    module.exports = omit;
  }
});

// ../../node_modules/mout/object/pick.js
var require_pick = __commonJS({
  "../../node_modules/mout/object/pick.js"(exports, module) {
    "use strict";
    var slice = require_slice();
    function pick(obj, var_keys) {
      var keys = typeof arguments[1] !== "string" ? arguments[1] : slice(arguments, 1), out = {}, i = 0, key;
      while (key = keys[i++]) {
        out[key] = obj[key];
      }
      return out;
    }
    __name(pick, "pick");
    module.exports = pick;
  }
});

// ../../node_modules/mout/object/pluck.js
var require_pluck = __commonJS({
  "../../node_modules/mout/object/pluck.js"(exports, module) {
    "use strict";
    var map = require_map();
    var prop = require_prop();
    function pluck(obj, propName) {
      return map(obj, prop(propName));
    }
    __name(pluck, "pluck");
    module.exports = pluck;
  }
});

// ../../node_modules/mout/object/size.js
var require_size = __commonJS({
  "../../node_modules/mout/object/size.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    function size(obj) {
      var count = 0;
      forOwn(obj, function() {
        count++;
      });
      return count;
    }
    __name(size, "size");
    module.exports = size;
  }
});

// ../../node_modules/mout/object/reduce.js
var require_reduce = __commonJS({
  "../../node_modules/mout/object/reduce.js"(exports, module) {
    "use strict";
    var forOwn = require_forOwn();
    var size = require_size();
    function reduce(obj, callback, memo, thisObj) {
      var initial = arguments.length > 2;
      if (!size(obj) && !initial) {
        throw new Error("reduce of empty object with no initial value");
      }
      forOwn(obj, function(value, key, list) {
        if (!initial) {
          memo = value;
          initial = true;
        } else {
          memo = callback.call(thisObj, memo, value, key, list);
        }
      });
      return memo;
    }
    __name(reduce, "reduce");
    module.exports = reduce;
  }
});

// ../../node_modules/mout/object/reject.js
var require_reject = __commonJS({
  "../../node_modules/mout/object/reject.js"(exports, module) {
    "use strict";
    var filter = require_filter();
    var makeIterator = require_makeIterator();
    function reject(obj, callback, thisObj) {
      callback = makeIterator(callback, thisObj);
      return filter(obj, function(value, index, obj2) {
        return !callback(value, index, obj2);
      }, thisObj);
    }
    __name(reject, "reject");
    module.exports = reject;
  }
});

// ../../node_modules/mout/lang/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/mout/lang/isFunction.js"(exports, module) {
    "use strict";
    var isKind = require_isKind();
    function isFunction(val) {
      return isKind(val, "Function");
    }
    __name(isFunction, "isFunction");
    module.exports = isFunction;
  }
});

// ../../node_modules/mout/object/result.js
var require_result = __commonJS({
  "../../node_modules/mout/object/result.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    function result(obj, prop) {
      var property = obj[prop];
      if (property === void 0) {
        return;
      }
      return isFunction(property) ? property.call(obj) : property;
    }
    __name(result, "result");
    module.exports = result;
  }
});

// ../../node_modules/mout/object/set.js
var require_set = __commonJS({
  "../../node_modules/mout/object/set.js"(exports, module) {
    "use strict";
    var namespace = require_namespace();
    function set(obj, prop, val) {
      var stringifiedProp = prop.toString();
      if (stringifiedProp.includes("__proto__") || stringifiedProp.includes("prototype") || stringifiedProp.includes("constructor")) {
        return false;
      }
      var parts = /^(.+)\.(.+)$/.exec(stringifiedProp);
      if (parts) {
        namespace(obj, parts[1])[parts[2]] = val;
      } else {
        obj[stringifiedProp] = val;
      }
    }
    __name(set, "set");
    module.exports = set;
  }
});

// ../../node_modules/mout/object/unset.js
var require_unset = __commonJS({
  "../../node_modules/mout/object/unset.js"(exports, module) {
    "use strict";
    var has = require_has();
    function unset(obj, prop) {
      if (has(obj, prop)) {
        var parts = prop.split("."), last = parts.pop();
        while (prop = parts.shift()) {
          obj = obj[prop];
        }
        return delete obj[last];
      } else {
        return true;
      }
    }
    __name(unset, "unset");
    module.exports = unset;
  }
});

// ../../node_modules/mout/object.js
var require_object = __commonJS({
  "../../node_modules/mout/object.js"(exports, module) {
    "use strict";
    module.exports = {
      "bindAll": require_bindAll(),
      "contains": require_contains(),
      "deepFillIn": require_deepFillIn(),
      "deepMatches": require_deepMatches(),
      "deepMixIn": require_deepMixIn(),
      "equals": require_equals(),
      "every": require_every(),
      "fillIn": require_fillIn(),
      "filter": require_filter(),
      "find": require_find(),
      "flatten": require_flatten(),
      "forIn": require_forIn(),
      "forOwn": require_forOwn(),
      "functions": require_functions(),
      "get": require_get(),
      "has": require_has(),
      "hasOwn": require_hasOwn(),
      "keys": require_keys(),
      "map": require_map(),
      "matches": require_matches(),
      "max": require_max2(),
      "merge": require_merge(),
      "min": require_min2(),
      "mixIn": require_mixIn(),
      "namespace": require_namespace(),
      "omit": require_omit(),
      "pick": require_pick(),
      "pluck": require_pluck(),
      "reduce": require_reduce(),
      "reject": require_reject(),
      "result": require_result(),
      "set": require_set(),
      "size": require_size(),
      "some": require_some(),
      "unset": require_unset(),
      "values": require_values()
    };
  }
});

// ../../node_modules/iso-3166-1-alpha-2/index.js
var require_iso_3166_1_alpha_2 = __commonJS({
  "../../node_modules/iso-3166-1-alpha-2/index.js"(exports, module) {
    "use strict";
    (function() {
      var Iso31661a2, mout, singleton;
      mout = require_object();
      Iso31661a2 = function() {
        function Iso31661a22() {
        }
        __name(Iso31661a22, "Iso31661a2");
        Iso31661a22.prototype.getCountry = function(code) {
          return Iso31661a22.prototype.countries[code];
        };
        Iso31661a22.prototype.getCode = function(country) {
          var idx, ret;
          ret = null;
          if (country != null) {
            idx = mout.values(Iso31661a22.prototype.countries).indexOf(country);
            if (idx !== -1) {
              ret = Object.keys(Iso31661a22.prototype.countries)[idx];
            }
          }
          return ret;
        };
        Iso31661a22.prototype.getCountries = function() {
          return mout.values(Iso31661a22.prototype.countries);
        };
        Iso31661a22.prototype.getCodes = function() {
          return Object.keys(Iso31661a22.prototype.countries);
        };
        Iso31661a22.prototype.getData = function() {
          return Iso31661a22.prototype.countries;
        };
        Iso31661a22.prototype.countries = {
          AF: "Afghanistan",
          AX: "\xC5land Islands",
          AL: "Albania",
          DZ: "Algeria",
          AS: "American Samoa",
          AD: "Andorra",
          AO: "Angola",
          AI: "Anguilla",
          AQ: "Antarctica",
          AG: "Antigua and Barbuda",
          AR: "Argentina",
          AM: "Armenia",
          AW: "Aruba",
          AU: "Australia",
          AT: "Austria",
          AZ: "Azerbaijan",
          BS: "Bahamas",
          BH: "Bahrain",
          BD: "Bangladesh",
          BB: "Barbados",
          BY: "Belarus",
          BE: "Belgium",
          BZ: "Belize",
          BJ: "Benin",
          BM: "Bermuda",
          BT: "Bhutan",
          BO: "Bolivia, Plurinational State of",
          BQ: "Bonaire, Sint Eustatius and Saba",
          BA: "Bosnia and Herzegovina",
          BW: "Botswana",
          BV: "Bouvet Island",
          BR: "Brazil",
          IO: "British Indian Ocean Territory",
          BN: "Brunei Darussalam",
          BG: "Bulgaria",
          BF: "Burkina Faso",
          BI: "Burundi",
          KH: "Cambodia",
          CM: "Cameroon",
          CA: "Canada",
          CV: "Cape Verde",
          KY: "Cayman Islands",
          CF: "Central African Republic",
          TD: "Chad",
          CL: "Chile",
          CN: "China",
          CX: "Christmas Island",
          CC: "Cocos (Keeling) Islands",
          CO: "Colombia",
          KM: "Comoros",
          CG: "Congo",
          CD: "Congo, the Democratic Republic of the",
          CK: "Cook Islands",
          CR: "Costa Rica",
          CI: "C\xF4te d'Ivoire",
          HR: "Croatia",
          CU: "Cuba",
          CW: "Cura\xE7ao",
          CY: "Cyprus",
          CZ: "Czech Republic",
          DK: "Denmark",
          DJ: "Djibouti",
          DM: "Dominica",
          DO: "Dominican Republic",
          EC: "Ecuador",
          EG: "Egypt",
          SV: "El Salvador",
          GQ: "Equatorial Guinea",
          ER: "Eritrea",
          EE: "Estonia",
          ET: "Ethiopia",
          FK: "Falkland Islands (Malvinas)",
          FO: "Faroe Islands",
          FJ: "Fiji",
          FI: "Finland",
          FR: "France",
          GF: "French Guiana",
          PF: "French Polynesia",
          TF: "French Southern Territories",
          GA: "Gabon",
          GM: "Gambia",
          GE: "Georgia",
          DE: "Germany",
          GH: "Ghana",
          GI: "Gibraltar",
          GR: "Greece",
          GL: "Greenland",
          GD: "Grenada",
          GP: "Guadeloupe",
          GU: "Guam",
          GT: "Guatemala",
          GG: "Guernsey",
          GN: "Guinea",
          GW: "Guinea-Bissau",
          GY: "Guyana",
          HT: "Haiti",
          HM: "Heard Island and McDonald Mcdonald Islands",
          VA: "Holy See (Vatican City State)",
          HN: "Honduras",
          HK: "Hong Kong",
          HU: "Hungary",
          IS: "Iceland",
          IN: "India",
          ID: "Indonesia",
          IR: "Iran, Islamic Republic of",
          IQ: "Iraq",
          IE: "Ireland",
          IM: "Isle of Man",
          IL: "Israel",
          IT: "Italy",
          JM: "Jamaica",
          JP: "Japan",
          JE: "Jersey",
          JO: "Jordan",
          KZ: "Kazakhstan",
          KE: "Kenya",
          KI: "Kiribati",
          XK: "Kosovo",
          KP: "Korea, Democratic People's Republic of",
          KR: "Korea, Republic of",
          KW: "Kuwait",
          KG: "Kyrgyzstan",
          LA: "Lao People's Democratic Republic",
          LV: "Latvia",
          LB: "Lebanon",
          LS: "Lesotho",
          LR: "Liberia",
          LY: "Libya",
          LI: "Liechtenstein",
          LT: "Lithuania",
          LU: "Luxembourg",
          MO: "Macao",
          MK: "Macedonia, the Former Yugoslav Republic of",
          MG: "Madagascar",
          MW: "Malawi",
          MY: "Malaysia",
          MV: "Maldives",
          ML: "Mali",
          MT: "Malta",
          MH: "Marshall Islands",
          MQ: "Martinique",
          MR: "Mauritania",
          MU: "Mauritius",
          YT: "Mayotte",
          MX: "Mexico",
          FM: "Micronesia, Federated States of",
          MD: "Moldova, Republic of",
          MC: "Monaco",
          MN: "Mongolia",
          ME: "Montenegro",
          MS: "Montserrat",
          MA: "Morocco",
          MZ: "Mozambique",
          MM: "Myanmar",
          NA: "Namibia",
          NR: "Nauru",
          NP: "Nepal",
          NL: "Netherlands",
          AN: "Netherlands Antilles",
          NC: "New Caledonia",
          NZ: "New Zealand",
          NI: "Nicaragua",
          NE: "Niger",
          NG: "Nigeria",
          NU: "Niue",
          NF: "Norfolk Island",
          MP: "Northern Mariana Islands",
          NO: "Norway",
          OM: "Oman",
          PK: "Pakistan",
          PW: "Palau",
          PS: "Palestine, State of",
          PA: "Panama",
          PG: "Papua New Guinea",
          PY: "Paraguay",
          PE: "Peru",
          PH: "Philippines",
          PN: "Pitcairn",
          PL: "Poland",
          PT: "Portugal",
          PR: "Puerto Rico",
          QA: "Qatar",
          RE: "R\xE9union",
          RO: "Romania",
          RU: "Russian Federation",
          RW: "Rwanda",
          BL: "Saint Barth\xE9lemy",
          SH: "Saint Helena, Ascension and Tristan da Cunha",
          KN: "Saint Kitts and Nevis",
          LC: "Saint Lucia",
          MF: "Saint Martin (French part)",
          PM: "Saint Pierre and Miquelon",
          VC: "Saint Vincent and the Grenadines",
          WS: "Samoa",
          SM: "San Marino",
          ST: "Sao Tome and Principe",
          SA: "Saudi Arabia",
          SN: "Senegal",
          RS: "Serbia",
          SC: "Seychelles",
          SL: "Sierra Leone",
          SG: "Singapore",
          SX: "Sint Maarten (Dutch part)",
          SK: "Slovakia",
          SI: "Slovenia",
          SB: "Solomon Islands",
          SO: "Somalia",
          ZA: "South Africa",
          GS: "South Georgia and the South Sandwich Islands",
          SS: "South Sudan",
          ES: "Spain",
          LK: "Sri Lanka",
          SD: "Sudan",
          SR: "Suriname",
          SJ: "Svalbard and Jan Mayen",
          SZ: "Swaziland",
          SE: "Sweden",
          CH: "Switzerland",
          SY: "Syrian Arab Republic",
          TW: "Taiwan, Province of China",
          TJ: "Tajikistan",
          TZ: "Tanzania, United Republic of",
          TH: "Thailand",
          TL: "Timor-Leste",
          TG: "Togo",
          TK: "Tokelau",
          TO: "Tonga",
          TT: "Trinidad and Tobago",
          TN: "Tunisia",
          TR: "Turkey",
          TM: "Turkmenistan",
          TC: "Turks and Caicos Islands",
          TV: "Tuvalu",
          UG: "Uganda",
          UA: "Ukraine",
          AE: "United Arab Emirates",
          GB: "United Kingdom",
          US: "United States",
          UM: "United States Minor Outlying Islands",
          UY: "Uruguay",
          UZ: "Uzbekistan",
          VU: "Vanuatu",
          VE: "Venezuela, Bolivarian Republic of",
          VN: "Viet Nam",
          VG: "Virgin Islands, British",
          VI: "Virgin Islands, U.S.",
          WF: "Wallis and Futuna",
          EH: "Western Sahara",
          YE: "Yemen",
          ZM: "Zambia",
          ZW: "Zimbabwe"
        };
        return Iso31661a22;
      }();
      singleton = null;
      module.exports = function() {
        return singleton != null ? singleton : singleton = new Iso31661a2();
      }();
    }).call(exports);
  }
});

// src/airline-iata.schema.ts
import { z } from "zod";
var airlineIataSchema = z.string().length(2, {
  message: "airlineIata must be an existing 2-alphanumeric characters code (omit the *, if any)"
});

// src/booking-number.schema.ts
import { z as z2 } from "zod";
var bookingNumberSchema = z2.string().min(4).max(255);

// src/country.schema.ts
import { z as z4 } from "zod";

// src/country-code.schema.ts
import { extendApi } from "@anatine/zod-openapi";
import { z as z3 } from "zod";
import { CountryCodes } from "@repo/lib-koala-types";
var message = /* @__PURE__ */ __name((value) => ({
  message: `${value} is not a valid ISO 3166-1-alpha-2 code`
}), "message");
var isCountryCode = /* @__PURE__ */ __name((input) => CountryCodes.includes(input), "isCountryCode");
var countryCodeSchema = extendApi(z3.string().toUpperCase().pipe(z3.custom(isCountryCode, message)), {
  description: [
    "A two-letter ISO 3166-1-alpha-2 country code.",
    "You can precise a country of residence if the quote is restricted to specific areas"
  ].join(""),
  example: "FR",
  type: "string"
});

// src/country.schema.ts
var countrySchema = z4.strictObject({
  id: countryCodeSchema,
  name: z4.string()
});

// src/currency.schema.ts
import { extendApi as extendApi2 } from "@anatine/zod-openapi";
import { codes } from "currency-codes";
import { z as z5 } from "zod";
var message2 = /* @__PURE__ */ __name((value) => ({
  message: `${value} is not a valid ISO 4217 code`
}), "message");
var isoCurrencySchema = extendApi2(z5.string().refine((input) => codes().includes(input), message2), {
  description: "Currency of the price in ISO 4217 format.",
  enum: codes(),
  example: "EUR"
});

// src/datetime.schema.ts
import { extendApi as extendApi3 } from "@anatine/zod-openapi";
import { DateTime } from "luxon";
import { z as z6 } from "zod";
function validateDateTime(date) {
  return DateTime.isDateTime(date) && date.isValid;
}
__name(validateDateTime, "validateDateTime");
function validateFixedDateTimeWithTimeZone(date) {
  return validateDateTime(date) && date.isOffsetFixed;
}
__name(validateFixedDateTimeWithTimeZone, "validateFixedDateTimeWithTimeZone");
var isoWithOffsetRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?|\.\d+)?(Z|[+-]\d{2}(:?\d{2})?)$/;
var isoWithoutOffsetRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/;
var dateTimeWithUtcOffsetSchema = extendApi3(z6.string().refine(
  // FIXME: Zod's built-in z.string().datetime({ offset: true }) schema could be used instead of a custom regex, but it requires a bump of Zod to
  //  3.24.4 because it is the specific version in which they fix the schema to allow the string to not contain the
  //  seconds. Since bumping Zod might break compatibility with front-end libraries, I'd rather not do it in
  //  emergency.
  (date) => isoWithOffsetRegex.test(date),
  'String must be a <a href="https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC">qualified ISO 8601 date-time</a> (with time zone from UTC)'
).transform((date) => DateTime.fromISO(date, {
  setZone: true
})).pipe(z6.custom(validateFixedDateTimeWithTimeZone, 'String must be a <a href="https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC">qualified ISO 8601 date-time</a> (with time zone from UTC)')), {
  description: "Expected <strong>local</strong> arrival <strong>date time</strong> following the ISO 8601 format with a time zone.",
  example: DateTime.utc().setZone("America/New_York").plus({
    months: 1
  }).startOf("hour").plus({
    hours: 8,
    minutes: 21
  }).toISO(),
  format: "date-time",
  type: "string"
});
var dateTimeWithoutUtcOffsetSchema = extendApi3(z6.string().refine((date) => isoWithoutOffsetRegex.test(date), 'String must be an <a href="https://en.wikipedia.org/wiki/ISO_8601#Local_time_(unqualified)">unqualified ISO 8601 date-time</a> (without time zone)').transform((date) => DateTime.fromISO(date, {
  setZone: true
})).pipe(z6.custom(validateDateTime, 'String must be an <a href="https://en.wikipedia.org/wiki/ISO_8601#Local_time_(unqualified)">unqualified ISO 8601 date-time</a> (without time zone)')), {
  description: "Expected <strong>local</strong> arrival <strong>date time</strong> following the ISO 8601 format without time zone.",
  example: DateTime.utc().plus({
    months: 1
  }).startOf("hour").plus({
    hours: 8,
    minutes: 21
  }).toISO({
    includeOffset: false
  }),
  format: "date-time",
  type: "string"
});
var isoDateTimeWithZuluOffsetSchema = extendApi3(z6.string().datetime().transform((date) => DateTime.fromISO(date)));

// src/duration.schema.ts
import { Duration } from "luxon";
import { z as z7 } from "zod";
var durationSchema = z7.string().duration().transform((duration) => Duration.fromISO(duration)).refine((duration) => duration.isValid, {
  message: "Duration must be a a string in the ISO 8601 Duration format"
});

// src/email.schema.ts
import validator from "validator";
import { z as z8 } from "zod";
var emailSchema = z8.union([
  z8.string().email(),
  z8.string().superRefine((value, ctx) => {
    if (!validator.isEmail(value, {
      allow_ip_domain: true
    })) {
      ctx.addIssue({
        code: z8.ZodIssueCode.invalid_string,
        validation: "email"
      });
    }
  })
]);
var commaSeparatedEmailsSchema = z8.string().refine((value) => {
  if (!value) {
    return true;
  }
  const emails = value.split(",").map((email) => email.trim());
  return emails.every((email) => emailSchema.safeParse(email).success);
}, {
  message: "Each comma-separated value must be a valid email address"
});

// src/flexible-boolean.schema.ts
import { z as z9 } from "zod";
var flexibleBooleanSchema = z9.boolean().or(z9.enum([
  "true",
  "false"
]).transform((value) => value === "true"));

// src/flight-number.schema.ts
import { extendApi as extendApi4 } from "@anatine/zod-openapi";
import { z as z10 } from "zod";
var flightNumberSchema = extendApi4(z10.string().min(1).regex(/\d+/).max(4), {
  description: "Flight number.",
  example: "263"
});

// src/iata.schema.ts
import { z as z11 } from "zod";
var iataSchema = z11.string().length(3, {
  message: "iata must be an existing 3-letter geocode"
});

// src/language.schema.ts
import { extendApi as extendApi5 } from "@anatine/zod-openapi";

// ../../node_modules/iso-639-1/src/data.js
var LANGUAGES_LIST = {
  aa: {
    name: "Afar",
    nativeName: "Afaraf"
  },
  ab: {
    name: "Abkhaz",
    nativeName: "\u0430\u04A7\u0441\u0443\u0430 \u0431\u044B\u0437\u0448\u04D9\u0430"
  },
  ae: {
    name: "Avestan",
    nativeName: "avesta"
  },
  af: {
    name: "Afrikaans",
    nativeName: "Afrikaans"
  },
  ak: {
    name: "Akan",
    nativeName: "Akan"
  },
  am: {
    name: "Amharic",
    nativeName: "\u12A0\u121B\u122D\u129B"
  },
  an: {
    name: "Aragonese",
    nativeName: "aragon\xE9s"
  },
  ar: {
    name: "Arabic",
    nativeName: "\u0627\u064E\u0644\u0652\u0639\u064E\u0631\u064E\u0628\u0650\u064A\u064E\u0651\u0629\u064F"
  },
  as: {
    name: "Assamese",
    nativeName: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE"
  },
  av: {
    name: "Avaric",
    nativeName: "\u0430\u0432\u0430\u0440 \u043C\u0430\u0446\u04C0"
  },
  ay: {
    name: "Aymara",
    nativeName: "aymar aru"
  },
  az: {
    name: "Azerbaijani",
    nativeName: "az\u0259rbaycan dili"
  },
  ba: {
    name: "Bashkir",
    nativeName: "\u0431\u0430\u0448\u04A1\u043E\u0440\u0442 \u0442\u0435\u043B\u0435"
  },
  be: {
    name: "Belarusian",
    nativeName: "\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430"
  },
  bg: {
    name: "Bulgarian",
    nativeName: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A"
  },
  bi: {
    name: "Bislama",
    nativeName: "Bislama"
  },
  bm: {
    name: "Bambara",
    nativeName: "bamanankan"
  },
  bn: {
    name: "Bengali",
    nativeName: "\u09AC\u09BE\u0982\u09B2\u09BE"
  },
  bo: {
    name: "Tibetan",
    nativeName: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42"
  },
  br: {
    name: "Breton",
    nativeName: "brezhoneg"
  },
  bs: {
    name: "Bosnian",
    nativeName: "bosanski jezik"
  },
  ca: {
    name: "Catalan",
    nativeName: "Catal\xE0"
  },
  ce: {
    name: "Chechen",
    nativeName: "\u043D\u043E\u0445\u0447\u0438\u0439\u043D \u043C\u043E\u0442\u0442"
  },
  ch: {
    name: "Chamorro",
    nativeName: "Chamoru"
  },
  co: {
    name: "Corsican",
    nativeName: "corsu"
  },
  cr: {
    name: "Cree",
    nativeName: "\u14C0\u1426\u1403\u152D\u140D\u140F\u1423"
  },
  cs: {
    name: "Czech",
    nativeName: "\u010De\u0161tina"
  },
  cu: {
    name: "Old Church Slavonic",
    nativeName: "\u0469\u0437\u044B\u043A\u044A \u0441\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A"
  },
  cv: {
    name: "Chuvash",
    nativeName: "\u0447\u04D1\u0432\u0430\u0448 \u0447\u04D7\u043B\u0445\u0438"
  },
  cy: {
    name: "Welsh",
    nativeName: "Cymraeg"
  },
  da: {
    name: "Danish",
    nativeName: "dansk"
  },
  de: {
    name: "German",
    nativeName: "Deutsch"
  },
  dv: {
    name: "Divehi",
    nativeName: "\u078B\u07A8\u0788\u07AC\u0780\u07A8"
  },
  dz: {
    name: "Dzongkha",
    nativeName: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41"
  },
  ee: {
    name: "Ewe",
    nativeName: "E\u028Begbe"
  },
  el: {
    name: "Greek",
    nativeName: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
  },
  en: {
    name: "English",
    nativeName: "English"
  },
  eo: {
    name: "Esperanto",
    nativeName: "Esperanto"
  },
  es: {
    name: "Spanish",
    nativeName: "Espa\xF1ol"
  },
  et: {
    name: "Estonian",
    nativeName: "eesti"
  },
  eu: {
    name: "Basque",
    nativeName: "euskara"
  },
  fa: {
    name: "Persian",
    nativeName: "\u0641\u0627\u0631\u0633\u06CC"
  },
  ff: {
    name: "Fula",
    nativeName: "Fulfulde"
  },
  fi: {
    name: "Finnish",
    nativeName: "suomi"
  },
  fj: {
    name: "Fijian",
    nativeName: "vosa Vakaviti"
  },
  fo: {
    name: "Faroese",
    nativeName: "f\xF8royskt"
  },
  fr: {
    name: "French",
    nativeName: "Fran\xE7ais"
  },
  fy: {
    name: "Western Frisian",
    nativeName: "Frysk"
  },
  ga: {
    name: "Irish",
    nativeName: "Gaeilge"
  },
  gd: {
    name: "Scottish Gaelic",
    nativeName: "G\xE0idhlig"
  },
  gl: {
    name: "Galician",
    nativeName: "galego"
  },
  gn: {
    name: "Guaran\xED",
    nativeName: "Ava\xF1e'\u1EBD"
  },
  gu: {
    name: "Gujarati",
    nativeName: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0"
  },
  gv: {
    name: "Manx",
    nativeName: "Gaelg"
  },
  ha: {
    name: "Hausa",
    nativeName: "\u0647\u064E\u0648\u064F\u0633\u064E"
  },
  he: {
    name: "Hebrew",
    nativeName: "\u05E2\u05D1\u05E8\u05D9\u05EA"
  },
  hi: {
    name: "Hindi",
    nativeName: "\u0939\u093F\u0928\u094D\u0926\u0940"
  },
  ho: {
    name: "Hiri Motu",
    nativeName: "Hiri Motu"
  },
  hr: {
    name: "Croatian",
    nativeName: "Hrvatski"
  },
  ht: {
    name: "Haitian",
    nativeName: "Krey\xF2l ayisyen"
  },
  hu: {
    name: "Hungarian",
    nativeName: "magyar"
  },
  hy: {
    name: "Armenian",
    nativeName: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576"
  },
  hz: {
    name: "Herero",
    nativeName: "Otjiherero"
  },
  ia: {
    name: "Interlingua",
    nativeName: "Interlingua"
  },
  id: {
    name: "Indonesian",
    nativeName: "Bahasa Indonesia"
  },
  ie: {
    name: "Interlingue",
    nativeName: "Interlingue"
  },
  ig: {
    name: "Igbo",
    nativeName: "As\u1EE5s\u1EE5 Igbo"
  },
  ii: {
    name: "Nuosu",
    nativeName: "\uA188\uA320\uA4BF Nuosuhxop"
  },
  ik: {
    name: "Inupiaq",
    nativeName: "I\xF1upiaq"
  },
  io: {
    name: "Ido",
    nativeName: "Ido"
  },
  is: {
    name: "Icelandic",
    nativeName: "\xCDslenska"
  },
  it: {
    name: "Italian",
    nativeName: "Italiano"
  },
  iu: {
    name: "Inuktitut",
    nativeName: "\u1403\u14C4\u1483\u144E\u1450\u1466"
  },
  ja: {
    name: "Japanese",
    nativeName: "\u65E5\u672C\u8A9E"
  },
  jv: {
    name: "Javanese",
    nativeName: "basa Jawa"
  },
  ka: {
    name: "Georgian",
    nativeName: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
  },
  kg: {
    name: "Kongo",
    nativeName: "Kikongo"
  },
  ki: {
    name: "Kikuyu",
    nativeName: "G\u0129k\u0169y\u0169"
  },
  kj: {
    name: "Kwanyama",
    nativeName: "Kuanyama"
  },
  kk: {
    name: "Kazakh",
    nativeName: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456"
  },
  kl: {
    name: "Kalaallisut",
    nativeName: "kalaallisut"
  },
  km: {
    name: "Khmer",
    nativeName: "\u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6"
  },
  kn: {
    name: "Kannada",
    nativeName: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1"
  },
  ko: {
    name: "Korean",
    nativeName: "\uD55C\uAD6D\uC5B4"
  },
  kr: {
    name: "Kanuri",
    nativeName: "Kanuri"
  },
  ks: {
    name: "Kashmiri",
    nativeName: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940"
  },
  ku: {
    name: "Kurdish",
    nativeName: "Kurd\xEE"
  },
  kv: {
    name: "Komi",
    nativeName: "\u043A\u043E\u043C\u0438 \u043A\u044B\u0432"
  },
  kw: {
    name: "Cornish",
    nativeName: "Kernewek"
  },
  ky: {
    name: "Kyrgyz",
    nativeName: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430"
  },
  la: {
    name: "Latin",
    nativeName: "latine"
  },
  lb: {
    name: "Luxembourgish",
    nativeName: "L\xEBtzebuergesch"
  },
  lg: {
    name: "Ganda",
    nativeName: "Luganda"
  },
  li: {
    name: "Limburgish",
    nativeName: "Limburgs"
  },
  ln: {
    name: "Lingala",
    nativeName: "Ling\xE1la"
  },
  lo: {
    name: "Lao",
    nativeName: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7"
  },
  lt: {
    name: "Lithuanian",
    nativeName: "lietuvi\u0173 kalba"
  },
  lu: {
    name: "Luba-Katanga",
    nativeName: "Kiluba"
  },
  lv: {
    name: "Latvian",
    nativeName: "latvie\u0161u valoda"
  },
  mg: {
    name: "Malagasy",
    nativeName: "fiteny malagasy"
  },
  mh: {
    name: "Marshallese",
    nativeName: "Kajin M\u0327aje\u013C"
  },
  mi: {
    name: "M\u0101ori",
    nativeName: "te reo M\u0101ori"
  },
  mk: {
    name: "Macedonian",
    nativeName: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A"
  },
  ml: {
    name: "Malayalam",
    nativeName: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02"
  },
  mn: {
    name: "Mongolian",
    nativeName: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B"
  },
  mr: {
    name: "Marathi",
    nativeName: "\u092E\u0930\u093E\u0920\u0940"
  },
  ms: {
    name: "Malay",
    nativeName: "Bahasa Melayu"
  },
  mt: {
    name: "Maltese",
    nativeName: "Malti"
  },
  my: {
    name: "Burmese",
    nativeName: "\u1017\u1019\u102C\u1005\u102C"
  },
  na: {
    name: "Nauru",
    nativeName: "Dorerin Naoero"
  },
  nb: {
    name: "Norwegian Bokm\xE5l",
    nativeName: "Norsk bokm\xE5l"
  },
  nd: {
    name: "Northern Ndebele",
    nativeName: "isiNdebele"
  },
  ne: {
    name: "Nepali",
    nativeName: "\u0928\u0947\u092A\u093E\u0932\u0940"
  },
  ng: {
    name: "Ndonga",
    nativeName: "Owambo"
  },
  nl: {
    name: "Dutch",
    nativeName: "Nederlands"
  },
  nn: {
    name: "Norwegian Nynorsk",
    nativeName: "Norsk nynorsk"
  },
  no: {
    name: "Norwegian",
    nativeName: "Norsk"
  },
  nr: {
    name: "Southern Ndebele",
    nativeName: "isiNdebele"
  },
  nv: {
    name: "Navajo",
    nativeName: "Din\xE9 bizaad"
  },
  ny: {
    name: "Chichewa",
    nativeName: "chiChe\u0175a"
  },
  oc: {
    name: "Occitan",
    nativeName: "occitan"
  },
  oj: {
    name: "Ojibwe",
    nativeName: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0"
  },
  om: {
    name: "Oromo",
    nativeName: "Afaan Oromoo"
  },
  or: {
    name: "Oriya",
    nativeName: "\u0B13\u0B21\u0B3C\u0B3F\u0B06"
  },
  os: {
    name: "Ossetian",
    nativeName: "\u0438\u0440\u043E\u043D \xE6\u0432\u0437\u0430\u0433"
  },
  pa: {
    name: "Panjabi",
    nativeName: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"
  },
  pi: {
    name: "P\u0101li",
    nativeName: "\u092A\u093E\u0934\u093F"
  },
  pl: {
    name: "Polish",
    nativeName: "Polski"
  },
  ps: {
    name: "Pashto",
    nativeName: "\u067E\u069A\u062A\u0648"
  },
  pt: {
    name: "Portuguese",
    nativeName: "Portugu\xEAs"
  },
  qu: {
    name: "Quechua",
    nativeName: "Runa Simi"
  },
  rm: {
    name: "Romansh",
    nativeName: "rumantsch grischun"
  },
  rn: {
    name: "Kirundi",
    nativeName: "Ikirundi"
  },
  ro: {
    name: "Romanian",
    nativeName: "Rom\xE2n\u0103"
  },
  ru: {
    name: "Russian",
    nativeName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
  },
  rw: {
    name: "Kinyarwanda",
    nativeName: "Ikinyarwanda"
  },
  sa: {
    name: "Sanskrit",
    nativeName: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D"
  },
  sc: {
    name: "Sardinian",
    nativeName: "sardu"
  },
  sd: {
    name: "Sindhi",
    nativeName: "\u0938\u093F\u0928\u094D\u0927\u0940"
  },
  se: {
    name: "Northern Sami",
    nativeName: "Davvis\xE1megiella"
  },
  sg: {
    name: "Sango",
    nativeName: "y\xE2ng\xE2 t\xEE s\xE4ng\xF6"
  },
  si: {
    name: "Sinhala",
    nativeName: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD"
  },
  sk: {
    name: "Slovak",
    nativeName: "sloven\u010Dina"
  },
  sl: {
    name: "Slovenian",
    nativeName: "sloven\u0161\u010Dina"
  },
  sm: {
    name: "Samoan",
    nativeName: "gagana fa'a Samoa"
  },
  sn: {
    name: "Shona",
    nativeName: "chiShona"
  },
  so: {
    name: "Somali",
    nativeName: "Soomaaliga"
  },
  sq: {
    name: "Albanian",
    nativeName: "Shqip"
  },
  sr: {
    name: "Serbian",
    nativeName: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"
  },
  ss: {
    name: "Swati",
    nativeName: "SiSwati"
  },
  st: {
    name: "Southern Sotho",
    nativeName: "Sesotho"
  },
  su: {
    name: "Sundanese",
    nativeName: "Basa Sunda"
  },
  sv: {
    name: "Swedish",
    nativeName: "Svenska"
  },
  sw: {
    name: "Swahili",
    nativeName: "Kiswahili"
  },
  ta: {
    name: "Tamil",
    nativeName: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"
  },
  te: {
    name: "Telugu",
    nativeName: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41"
  },
  tg: {
    name: "Tajik",
    nativeName: "\u0442\u043E\u04B7\u0438\u043A\u04E3"
  },
  th: {
    name: "Thai",
    nativeName: "\u0E44\u0E17\u0E22"
  },
  ti: {
    name: "Tigrinya",
    nativeName: "\u1275\u130D\u122D\u129B"
  },
  tk: {
    name: "Turkmen",
    nativeName: "T\xFCrkmen\xE7e"
  },
  tl: {
    name: "Tagalog",
    nativeName: "Wikang Tagalog"
  },
  tn: {
    name: "Tswana",
    nativeName: "Setswana"
  },
  to: {
    name: "Tonga",
    nativeName: "faka Tonga"
  },
  tr: {
    name: "Turkish",
    nativeName: "T\xFCrk\xE7e"
  },
  ts: {
    name: "Tsonga",
    nativeName: "Xitsonga"
  },
  tt: {
    name: "Tatar",
    nativeName: "\u0442\u0430\u0442\u0430\u0440 \u0442\u0435\u043B\u0435"
  },
  tw: {
    name: "Twi",
    nativeName: "Twi"
  },
  ty: {
    name: "Tahitian",
    nativeName: "Reo Tahiti"
  },
  ug: {
    name: "Uyghur",
    nativeName: "\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5\u200E"
  },
  uk: {
    name: "Ukrainian",
    nativeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
  },
  ur: {
    name: "Urdu",
    nativeName: "\u0627\u0631\u062F\u0648"
  },
  uz: {
    name: "Uzbek",
    nativeName: "\u040E\u0437\u0431\u0435\u043A"
  },
  ve: {
    name: "Venda",
    nativeName: "Tshiven\u1E13a"
  },
  vi: {
    name: "Vietnamese",
    nativeName: "Ti\u1EBFng Vi\u1EC7t"
  },
  vo: {
    name: "Volap\xFCk",
    nativeName: "Volap\xFCk"
  },
  wa: {
    name: "Walloon",
    nativeName: "walon"
  },
  wo: {
    name: "Wolof",
    nativeName: "Wollof"
  },
  xh: {
    name: "Xhosa",
    nativeName: "isiXhosa"
  },
  yi: {
    name: "Yiddish",
    nativeName: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9"
  },
  yo: {
    name: "Yoruba",
    nativeName: "Yor\xF9b\xE1"
  },
  za: {
    name: "Zhuang",
    nativeName: "Sa\u026F cue\u014B\u0185"
  },
  zh: {
    name: "Chinese",
    nativeName: "\u4E2D\u6587"
  },
  zu: {
    name: "Zulu",
    nativeName: "isiZulu"
  }
};
var data_default = LANGUAGES_LIST;

// ../../node_modules/iso-639-1/src/index.js
var ISO6391 = class _ISO6391 {
  static {
    __name(this, "ISO6391");
  }
  static getLanguages(codes2 = []) {
    return codes2.map((code) => ({
      code,
      name: _ISO6391.getName(code),
      nativeName: _ISO6391.getNativeName(code)
    }));
  }
  static getName(code) {
    return _ISO6391.validate(code) ? data_default[code].name : "";
  }
  static getAllNames() {
    return Object.values(data_default).map((l) => l.name);
  }
  static getNativeName(code) {
    return _ISO6391.validate(code) ? data_default[code].nativeName : "";
  }
  static getAllNativeNames() {
    return Object.values(data_default).map((l) => l.nativeName);
  }
  static getCode(name) {
    const code = Object.keys(data_default).find((code2) => {
      const language = data_default[code2];
      return language.name.toLowerCase() === name.toLowerCase() || language.nativeName.toLowerCase() === name.toLowerCase();
    });
    return code || "";
  }
  static getAllCodes() {
    return Object.keys(data_default);
  }
  static validate(code) {
    return data_default.hasOwnProperty(code);
  }
};

// ../../node_modules/iso-639-1-zh/src/data.js
var LANGUAGES_ZH_NAMES = {
  aa: "\u963F\u6CD5\u5C14\u8BED",
  ab: "\u963F\u5E03\u54C8\u5179\u8BED",
  ae: "\u963F\u7EF4\u65AF\u9640\u8BED",
  af: "\u5357\u975E\u8377\u5170\u8BED",
  ak: "\u963F\u574E\u8BED",
  am: "\u963F\u59C6\u54C8\u62C9\u8BED",
  an: "\u963F\u62C9\u8D21\u8BED",
  ar: "\u963F\u62C9\u4F2F\u8BED",
  as: "\u963F\u8428\u59C6\u8BED",
  av: "\u963F\u74E6\u5C14\u8BED",
  ay: "\u827E\u9A6C\u62C9\u8BED",
  az: "\u963F\u585E\u62DC\u7586\u8BED",
  ba: "\u5DF4\u4EC0\u57FA\u5C14\u8BED",
  be: "\u767D\u4FC4\u7F57\u65AF\u8BED",
  bg: "\u4FDD\u52A0\u5229\u4E9A\u8BED",
  bh: "\u6BD4\u54C8\u5C14\u8BED",
  bi: "\u6BD4\u65AF\u62C9\u9A6C\u8BED",
  bm: "\u73ED\u5DF4\u62C9\u8BED",
  bn: "\u5B5F\u52A0\u62C9\u8BED",
  bo: "\u85CF\u8BED",
  br: "\u5E03\u5217\u5854\u5C3C\u8BED",
  bs: "\u6CE2\u65AF\u5C3C\u4E9A\u8BED",
  ca: "\u52A0\u6CF0\u7F57\u5C3C\u4E9A\u8BED",
  ce: "\u8F66\u81E3\u8BED",
  ch: "\u67E5\u83AB\u6D1B\u8BED",
  co: "\u79D1\u897F\u5609\u8BED",
  cr: "\u514B\u91CC\u8BED",
  cs: "\u6377\u514B\u8BED",
  cu: "\u53E4\u6559\u4F1A\u65AF\u62C9\u592B\u8BED",
  cv: "\u695A\u74E6\u4EC0\u8BED",
  cy: "\u5A01\u5C14\u58EB\u8BED",
  da: "\u4E39\u9EA6\u8BED",
  de: "\u5FB7\u8BED",
  dv: "\u8FEA\u7EF4\u5E0C\u8BED",
  dz: "\u4E0D\u4E39\u8BED",
  ee: "\u57C3\u7EF4\u8BED",
  el: "\u5E0C\u814A\u8BED",
  en: "\u82F1\u8BED",
  eo: "\u4E16\u754C\u8BED",
  es: "\u897F\u73ED\u7259\u8BED",
  et: "\u7231\u6C99\u5C3C\u4E9A\u8BED",
  eu: "\u5DF4\u65AF\u514B\u8BED",
  fa: "\u6CE2\u65AF\u8BED",
  ff: "\u5BCC\u62C9\u8BED",
  fi: "\u82AC\u5170\u8BED",
  fj: "\u6590\u6D4E\u8BED",
  fo: "\u6CD5\u7F57\u8BED",
  fr: "\u6CD5\u8BED",
  fy: "\u897F\u5F17\u91CC\u897F\u4E9A\u8BED",
  ga: "\u7231\u5C14\u5170\u8BED",
  gd: "\u82CF\u683C\u5170\u76D6\u5C14\u8BED",
  gl: "\u52A0\u5229\u897F\u4E9A\u8BED",
  gn: "\u74DC\u62C9\u5C3C\u8BED",
  gu: "\u53E4\u5409\u62C9\u7279\u8BED",
  gv: "\u9A6C\u6069\u5C9B\u8BED",
  ha: "\u8C6A\u8428\u8BED",
  he: "\u5E0C\u4F2F\u6765\u8BED",
  hi: "\u5370\u5730\u8BED",
  ho: "\u83AB\u56FE\u8BED",
  hr: "\u514B\u7F57\u5730\u4E9A\u8BED",
  ht: "\u6D77\u5730\u6587",
  hu: "\u5308\u7259\u5229\u8BED",
  hy: "\u4E9A\u7F8E\u5C3C\u4E9A\u8BED",
  hz: "\u8D6B\u52D2\u5A04\u8BED",
  ia: "\u56FD\u9645\u8BED",
  id: "\u5370\u5C3C\u8BED",
  ie: "\u56FD\u9645\u8BED",
  ig: "\u4F0A\u535A\u8BED",
  ii: "\u8BFA\u82CF\u8BED",
  ik: "\u4F9D\u5974\u76AE\u7EF4\u514B\u6587",
  io: "\u4F0A\u591A\u6587",
  is: "\u51B0\u5C9B\u8BED",
  it: "\u610F\u5927\u5229\u8BED",
  iu: "\u56E0\u7EBD\u7279\u8BED",
  ja: "\u65E5\u8BED",
  jv: "\u722A\u54C7\u8BED",
  ka: "\u683C\u9C81\u5409\u4E9A\u8BED",
  kg: "\u521A\u679C\u8BED",
  ki: "\u57FA\u5E93\u5C24\u8BED",
  kj: "\u5BBD\u4E9A\u9A6C\u8BED",
  kk: "\u54C8\u8428\u514B\u8BED",
  kl: "\u683C\u9675\u5170\u8BED",
  km: "\u9AD8\u68C9\u8BED",
  kn: "\u5361\u7EB3\u8FBE\u8BED",
  ko: "\u97E9\u8BED",
  kr: "\u5361\u52AA\u91CC\u8BED",
  ks: "\u514B\u4EC0\u7C73\u5C14\u8BED",
  ku: "\u5E93\u5C14\u5FB7\u8BED",
  kv: "\u79D1\u7C73\u8BED",
  kw: "\u79D1\u5C3C\u4EC0\u8BED",
  ky: "\u5409\u5C14\u5409\u65AF\u8BED",
  la: "\u62C9\u4E01\u8BED",
  lb: "\u5362\u68EE\u5821\u8BED",
  lg: "\u7518\u8FBE\u8BED",
  li: "\u6797\u5821\u8BED",
  ln: "\u6797\u52A0\u62C9\u8BED",
  lo: "\u8001\u631D\u8BED",
  lt: "\u7ACB\u9676\u5B9B\u8BED",
  lu: "\u5362\u5DF4\u52A0\u4E39\u52A0\u8BED",
  lv: "\u62C9\u8131\u7EF4\u4E9A\u8BED",
  mg: "\u9A6C\u5C14\u52A0\u4EC0\u8BED",
  mh: "\u9A6C\u7ECD\u5C14\u8BED",
  mi: "\u6BDB\u5229\u8BED",
  mk: "\u9A6C\u5176\u987F\u8BED",
  ml: "\u9A6C\u62C9\u96C5\u62C9\u59C6\u8BED",
  mn: "\u8499\u53E4\u6587",
  mr: "\u9A6C\u62C9\u5730\u8BED",
  ms: "\u9A6C\u6765\u8BED",
  mt: "\u9A6C\u8033\u4ED6\u8BED",
  my: "\u7F05\u7538\u8BED",
  na: "\u7459\u9C81\u8BED",
  nb: "\u632A\u5A01\u535A\u514B\u9A6C\u5C14\u8BED",
  nd: "\u5317\u6069\u5FB7\u8D1D\u52D2\u8BED",
  ne: "\u5C3C\u6CCA\u5C14\u8BED",
  ng: "\u5C3C\u65E5\u5C14\u521A\u679C\u8BED",
  nl: "\u8377\u5170\u8BED",
  nn: "\u632A\u5A01\u5C3C\u8BFA\u65AF\u514B\u8BED",
  no: "\u632A\u5A01\u8BED",
  nr: "\u5357\u6069\u5FB7\u8D1D\u52D2\u8BED",
  nv: "\u7EB3\u74E6\u970D\u8BED",
  ny: "\u9F50\u5207\u74E6\u8BED",
  oc: "\u5965\u514B\u897F\u5510\u8BED",
  oj: "\u6B27\u53CA\u5E03\u5A01\u8BED",
  om: "\u5965\u7F57\u83AB\u8BED",
  or: "\u5965\u91CC\u4E9A\u8BED",
  os: "\u5965\u585E\u68AF\u8BED",
  pa: "\u65C1\u906E\u666E\u8BED",
  pi: "\u5DF4\u5229\u8BED",
  pl: "\u6CE2\u5170\u8BED",
  ps: "\u666E\u4EC0\u56FE\u8BED",
  pt: "\u8461\u8404\u7259\u8BED",
  qu: "\u514B\u4E18\u4E9A\u8BED",
  rm: "\u7F57\u66FC\u65AF\u8BED",
  rn: "\u57FA\u9686\u8FEA\u8BED",
  ro: "\u7F57\u9A6C\u5C3C\u4E9A\u8BED",
  ru: "\u4FC4\u8BED",
  rw: "\u5362\u65FA\u8FBE\u8BED",
  sa: "\u68B5\u6587",
  sc: "\u6492\u4E01\u5C9B\u8BED",
  sd: "\u4FE1\u5FB7\u8BED",
  se: "\u5317\u8428\u7C73\u6587",
  sg: "\u6851\u6208\u8BED",
  si: "\u50E7\u4F3D\u7F57\u8BED",
  sk: "\u65AF\u6D1B\u4F10\u514B\u8BED",
  sl: "\u65AF\u6D1B\u6587\u5C3C\u4E9A\u8BED",
  sm: "\u8428\u6469\u4E9A\u8BED",
  sn: "\u7ECD\u7EB3\u8BED",
  so: "\u7D22\u9A6C\u91CC\u8BED",
  sq: "\u963F\u5C14\u5DF4\u5C3C\u4E9A\u8BED",
  sr: "\u585E\u5C14\u7EF4\u4E9A\u8BED",
  ss: "\u65AF\u74E6\u8482\u8BED",
  st: "\u5357\u7D22\u6258\u8BED",
  su: "\u5DFD\u4ED6\u8BED",
  sv: "\u745E\u5178\u8BED",
  sw: "\u65AF\u74E6\u5E0C\u91CC\u8BED",
  ta: "\u6CF0\u7C73\u5C14\u8BED",
  te: "\u6CF0\u5362\u56FA\u8BED",
  tg: "\u5854\u5409\u514B\u8BED",
  th: "\u6CF0\u8BED",
  ti: "\u63D0\u683C\u96F7\u8BED",
  tk: "\u571F\u5E93\u66FC\u8BED",
  tl: "\u83F2\u5F8B\u5BBE\u8BED",
  tn: "\u8328\u74E6\u7EB3\u8BED",
  to: "\u6C64\u52A0\u8BED",
  tr: "\u571F\u8033\u5176\u8BED",
  ts: "\u7279\u677E\u52A0\u8BED",
  tt: "\u5854\u5854\u5C14\u8BED",
  tw: "\u5951\u7EF4\u8BED",
  ty: "\u5854\u5E0C\u63D0\u8BED",
  ug: "\u7EF4\u543E\u5C14\u8BED",
  uk: "\u4E4C\u514B\u5170\u8BED",
  ur: "\u4E4C\u5C14\u90FD\u8BED",
  uz: "\u4E4C\u5179\u522B\u514B\u8BED",
  ve: "\u6587\u8FBE\u8BED",
  vi: "\u8D8A\u5357\u8BED",
  vo: "\u6C83\u62C9\u666E\u514B\u8BED",
  wa: "\u534E\u9686\u8BED",
  wo: "\u6C83\u6D1B\u592B\u8BED",
  xh: "\u79D1\u8428\u8BED",
  yi: "\u610F\u7B2C\u7EEA\u8BED",
  yo: "\u7EA6\u9C81\u5DF4\u8BED",
  za: "\u58EE\u8BED",
  zh: "\u4E2D\u6587",
  zu: "\u7956\u9C81\u8BED"
};
var data_default2 = LANGUAGES_ZH_NAMES;

// ../../node_modules/iso-639-1-zh/src/index.js
var ISO6391ZH = class _ISO6391ZH extends ISO6391 {
  static {
    __name(this, "ISO6391ZH");
  }
  static getLanguages(codes2) {
    return super.getLanguages(codes2).map((language) => {
      Object.assign(language, {
        zhName: _ISO6391ZH.getZhName(language.code)
      });
      return language;
    });
  }
  static getZhName(code) {
    return super.validate(code) ? data_default2[code] : "";
  }
  static getAllZhNames() {
    return Object.values(data_default2);
  }
};

// ../../node_modules/locale-code/src/index.js
var import_iso_3166_1_alpha_2 = __toESM(require_iso_3166_1_alpha_2());
var REG = /^([a-z]{2})-([A-Z]{2})$/;
var LocaleCode = class _LocaleCode {
  static {
    __name(this, "LocaleCode");
  }
  /* language iso-639-1 */
  static getLanguageCode(code) {
    var match = code.match(REG);
    if (!match || match.length < 1) return "";
    return match[1];
  }
  static getLanguageName(code) {
    var languageCode = _LocaleCode.getLanguageCode(code);
    return ISO6391ZH.getName(languageCode);
  }
  static getLanguageNativeName(code) {
    var languageCode = _LocaleCode.getLanguageCode(code);
    return ISO6391ZH.getNativeName(languageCode);
  }
  static getLanguageZhName(code) {
    var languageCode = _LocaleCode.getLanguageCode(code);
    return ISO6391ZH.getZhName(languageCode);
  }
  static validateLanguageCode(code) {
    var languageCode = _LocaleCode.getLanguageCode(code);
    return ISO6391ZH.validate(languageCode);
  }
  static getLanguages(codes2) {
    var list = [];
    for (var i = 0; i < codes2.length; i++) {
      list.push({
        code: codes2[i],
        name: _LocaleCode.getLanguageName(codes2[i]),
        nativeName: _LocaleCode.getLanguageNativeName(codes2[i]),
        zhName: _LocaleCode.getLanguageZhName(codes2[i])
      });
    }
    return list;
  }
  /* country iso-3166-1-alpha-2 */
  static getCountryCode(code) {
    var match = code.match(REG);
    if (!match || match.length < 2) return "";
    return match[2];
  }
  static getCountryName(code) {
    var countryCode = _LocaleCode.getCountryCode(code);
    return import_iso_3166_1_alpha_2.default.getCountry(countryCode);
  }
  static validateCountryCode(code) {
    code = _LocaleCode.getCountryCode(code);
    if (import_iso_3166_1_alpha_2.default.getCodes().indexOf(code) === -1) {
      return false;
    } else {
      return true;
    }
  }
  /* validate */
  static validate(code) {
    var match = code.match(REG);
    if (match && match.length === 3 && _LocaleCode.validateLanguageCode(code) && _LocaleCode.validateCountryCode(code)) {
      return true;
    } else {
      return false;
    }
  }
};

// src/language.schema.ts
import { z as z12 } from "zod";
var languageSchema = extendApi5(z12.string().transform((l) => l.replace("_", "-")).refine((languageCode) => LocaleCode.validate(languageCode), (invalidLanguage) => ({
  message: `Language "${invalidLanguage}" is not a valid language code.`
})), {
  description: [
    "Language of the customer. It must be a country language code like ",
    "<code>[language designator]-[region designator]</code>, ",
    "with an ISO 639-1 alpha-2 code for the <code>language designator</code> ",
    "and an ISO 3166-1 for the <code>region designator</code>.<br />",
    "<strong>\u26A0\uFE0F Please be careful with filling this field as we use it to define ",
    "the language used for the travelers in all our communications.</strong>"
  ].join(""),
  example: "en-GB"
});

// src/latitude.schema.ts
import { z as z13 } from "zod";
var latitudeSchema = z13.number().min(-90).max(90);

// src/longitude.schema.ts
import { z as z14 } from "zod";
var longitudeSchema = z14.number().min(-180).max(180);

// src/number-with-max-decimal-places.ts
import { z as z15 } from "zod";
var DEFAULT_MAX_DECIMAL_PLACES = 4;
var numberWithMaxDecimalPlaces = z15.number().min(0).refine((n) => {
  const decimals = n.toString().split(".")[1];
  return decimals === void 0 || decimals.length <= DEFAULT_MAX_DECIMAL_PLACES;
}, {
  message: `Max precision is ${DEFAULT_MAX_DECIMAL_PLACES} decimal places`
});

// src/phone-number.schema.ts
import { parsePhoneNumber } from "libphonenumber-js";
import { z as z16 } from "zod";
var phoneNumberSchema = z16.string().refine((value) => {
  try {
    const phoneNumber = parsePhoneNumber(value);
    return phoneNumber.isValid();
  } catch (_error) {
    return false;
  }
});

// src/pir-reference.schema.ts
import { z as z17 } from "zod";
var pirReferenceSchema = z17.string().regex(/^[A-Z0-9]{10}$/, {
  message: "PIR reference must contain 10 characters, either uppercase letters or digits."
});

// src/price.schema.ts
import { extendApi as extendApi6 } from "@anatine/zod-openapi";
import { z as z19 } from "zod";

// src/price-amount.schema.ts
import { z as z18 } from "zod";
var MAX_DECIMAL_PRECISION = 4;
function decimalPlaces(n) {
  const s = `${+n}`;
  const match = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/.exec(s);
  if (!match) {
    return 0;
  }
  return Math.max(0, (match[1] === "0" ? 0 : (match[1] || "").length) - (+match[2] || 0));
}
__name(decimalPlaces, "decimalPlaces");
var priceAmountSchema = z18.number().min(0).refine((amount) => decimalPlaces(amount) <= MAX_DECIMAL_PRECISION, {
  message: `Amount with a maximum of ${MAX_DECIMAL_PRECISION} decimals.`
});

// src/price.schema.ts
var priceSchema = extendApi6(z19.strictObject({
  amount: extendApi6(priceAmountSchema, {
    description: `Amount with a maximum of ${MAX_DECIMAL_PRECISION} decimals.`,
    example: 103.86,
    type: "number"
  }),
  currency: extendApi6(isoCurrencySchema, {
    description: "Currency of the price in ISO 4217 format.",
    example: "EUR",
    type: "string"
  })
}), {
  type: "object"
});

// src/price-delta-amount.schema.ts
import { z as z20 } from "zod";
var priceDeltaAmountSchema = z20.number().refine((amount) => decimalPlaces(amount) <= MAX_DECIMAL_PRECISION, {
  message: `Amount with a maximum of ${MAX_DECIMAL_PRECISION} decimals.`
});

// src/price-delta.schema.ts
var priceDeltaSchema = priceSchema.extend({
  amount: priceDeltaAmountSchema
});

// src/timezone.schema.ts
import { IANAZone } from "luxon";
import { z as z21 } from "zod";
var timezoneSchema = z21.string().refine((value) => IANAZone.isValidZone(value), {
  message: "should be a valid IANA time zone name"
});

// src/uic.schema.ts
import { z as z22 } from "zod";
var uicSchema = z22.string().regex(/^\d{7}$/, "uic must be a 7-digit number");
export {
  MAX_DECIMAL_PRECISION,
  airlineIataSchema,
  bookingNumberSchema,
  commaSeparatedEmailsSchema,
  countryCodeSchema,
  countrySchema,
  dateTimeWithUtcOffsetSchema,
  dateTimeWithoutUtcOffsetSchema,
  decimalPlaces,
  durationSchema,
  emailSchema,
  flexibleBooleanSchema,
  flightNumberSchema,
  iataSchema,
  isoCurrencySchema,
  languageSchema,
  latitudeSchema,
  longitudeSchema,
  numberWithMaxDecimalPlaces,
  phoneNumberSchema,
  pirReferenceSchema,
  priceAmountSchema,
  priceDeltaAmountSchema,
  priceDeltaSchema,
  priceSchema,
  timezoneSchema,
  uicSchema
};
//# sourceMappingURL=index.js.map